import Ajax from '../js/common/ajax';
export default {
	list(params) {
		return Ajax.get("/property/list", params)
	},
	add(params = {}) {
		return Ajax.post("/property/add", params)
	},
	edit(params = {}) {
		return Ajax.post("/property/edit", params)
	},
	setStatus(id) {
		return Ajax.post("/property/setStatus/"+id)
	},
	del(id) {
		return Ajax.post("/property/del/"+id)
	},
	devalue(params ) {
		return Ajax.post("/property/devalue",params)
	},
	generateVoucher(params) {
		return Ajax.post("/property/generateVoucher",params)
	},
	
}